import Apify from '@module/apify';

export default Apify({
  sendContactMessage: {
    path: '/api/v4/advertise/contact-message',
    method: 'POST',
  },

  getGalleryItems: {
    path:
      'https://s3-eu-west-1.amazonaws.com/wetransfer-extra/advertgallery/tree.json',
    method: 'GET',
  },
});
